module.exports = "/lucky-balls/img/drum/drum_loop_029.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_029.png
// module id = 1044
// module chunks = 0